import {
  YOUR_DETAILS_FIELDS,
  MOBILE_PHONE_NUMBER,
  PHONE_NUMBER_ALTERNATIVE,
} from '../../../routes/about-you/about-you-form/sections/your-details/you-details-fields.config';

const extraProps = {
  label: null,
  className: null,
  autoFocus: true,
};

export const YOUR_DETAILS_FIELDS_REVIEW = {
  firstName: {
    ...YOUR_DETAILS_FIELDS[0],
    ...extraProps,
  },
  lastName: {
    ...YOUR_DETAILS_FIELDS[1],
    ...extraProps,
  },
  phoneNumber: {
    ...YOUR_DETAILS_FIELDS[2],
    ...extraProps,
    extra: null,
  },
  mobileNumber: {
    ...MOBILE_PHONE_NUMBER,
    ...extraProps,
    extra: null,
  },
  phoneNumberAlternative: {
    ...PHONE_NUMBER_ALTERNATIVE,
    ...extraProps,
    extra: null,
  },
};

export const YOUR_DETAILS_FIELDS_REVIEW_CONFIG = [...Object.values(YOUR_DETAILS_FIELDS_REVIEW)];
